import { jwtDecode } from 'jwt-decode';
import axios from 'src/utils/axios';

class AuthService {
  setAxiosInterceptors = ({ onLogout }) => {
    axios.interceptors.response.use(
      (response) => response,
      (error) => {
        // console.log({ error });
        // if (error.status === 401) 
        if (error?.response?.status === 401 || error?.status === 401) {
          
          this.setSession(null);

          if (onLogout) {
            onLogout();
          }
        }

        return Promise.reject(error);
      }
    );
  };

  handleAuthentication() {
    const accessToken = this.getAccessToken();

    if (!accessToken) {
      return;
    }

    if (this.isValidToken(accessToken)) {
      this.setSession(accessToken);
    } else {
      this.setSession(null);
    }
  }

  loginWithEmailAndPassword = (username, password) => new Promise((resolve, reject) => {


    const url = process.env.REACT_APP_API_BASE_URL + '/api/login';
    // console.log(url);

    axios.post(url, { username, password })
      .then((response) => {
        if (response.data.user) {
          this.setSession(response.data.accessToken);
          resolve(response.data.user);
        } else {
          reject(response.data.error);
        }
      })
      .catch((error) => {
        reject(error);
      });

  })

  loginInWithToken = () => new Promise((resolve, reject) => {
    axios.get(process.env.REACT_APP_API_BASE_URL + '/api/account/me')
      .then((response) => {
        if (response.data.user) {
          const user = response.data.user;

          // Kolla userType === 3
          if (user.usertype === 3 && !window.location.pathname.startsWith('/customerview')) {
            // Bygg redirect-URL
            const house = user.houseDenotation;
            const flat = user.flatDenotation;
            const backwardComp = user.backwardComp;

            if(backwardComp !== null && backwardComp !== ""){
              window.location.href = `/customerview/${house}-${backwardComp}-${flat}`;
            }else{
              window.location.href = `/customerview/${house}-${flat}`;
            }
            return; // Avsluta här för att inte köra resolve
          }

          resolve(user);
        } else {
          reject(response.data.error);
        }
      })
      .catch((error) => {
        reject(error);
      });
  })

  logout = () => {
    this.setSession(null);
  }

  setSession = (accessToken) => {
    if (accessToken) {
      localStorage.setItem('accessToken', accessToken);
      axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    } else {
      localStorage.removeItem('accessToken');
      delete axios.defaults.headers.common.Authorization;
    }
  }

  getAccessToken = () => localStorage.getItem('accessToken');

  isValidToken = (accessToken) => {
    if (!accessToken) {
      return false;
    }

    const decoded = jwtDecode(accessToken);
    const currentTime = Date.now() / 1000;

    return decoded.exp > currentTime;
  }

  isAuthenticated = () => !!this.getAccessToken()
}

const authService = new AuthService();

export default authService;
